import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import API from "../../../utils/helpers/APIHelper";
import { RootState } from "../../store";
// import { SignInRequestPayload, SignUpRequestPayload } from "./AuthSliceTypes";
import ErrorHandler from "../../../utils/helpers/ErrorHandler";
import { ENDPOINTS } from "../../../API/apiConstants";
import { PropertiesState } from "./PropertiesSliceTypes";
import { toast } from "react-toastify";

interface InvoicePayload {
  booking_id?: number;
  booking: {
    status: string;
    invoice_attributes: {
      status: string;
      billing_type: string;
      invoice_type: string;
      expenses_attributes: Expenses[];
      discounts_attributes: Discount[];
    };
  };
}

interface Expenses {
  category: string;
  amount: number;
}

interface Discount {
  description: string;
  amount: number;
}

const initialState: PropertiesState = {
  loading: false,
    error: null,  // ✅ ADD THIS LINE
  allProperties: [],
  propertiesCategories: [],
  AmenitiesCategories: [],
  houseRule: [],
  globalId: null,
  propertyToCreate: null,
  PropertyToEdit: null,
  details: null,
  propertyTypes: [],
  property: [],
  featuresCategories: [],
  allTex: [],
  roomamenitiesCategories: [],
  roomfeaturesCategories: [],
  bedType: [],
  roomType: [],
  bookings: [],
  invoiceData: [],
  metaData: {},
  requestBookings: [],
  favorites: [],
  Chat: {},
  booking: {},
  query: {},
  queryData: {},
  cancelTypes: [],
  blog: [],
  blogsDetails: [],
  getComment: [],
  exclusiveProperty: [],
  allreview: [],
  featuredProperty: [],
  activeProperties: [],
};

export const getAllProperties = createAsyncThunk<
  any, // Payload type for successful response (you may want to type this more strictly)
  any,
  { state: RootState; rejectValue: any }
>("properties/allProperties", async (page, { rejectWithValue }) => {
  try {
    const response = await API.get(ENDPOINTS.GET_ALL_PROPERTIES(page));
    return response; // Returning data directly, which contains user info
  } catch (error) {
    ErrorHandler(error);
    return rejectWithValue(error);
  }
});

export const getActiveProperties = createAsyncThunk<
  any,
  void,
  { state: RootState; rejectValue: any }
>("properties/activeProperties", async (_, { rejectWithValue }) => {
  try {
    const response = await API.get(ENDPOINTS.GET_ALL_PROPERTIES(1, 100));
    return response;
  } catch (error) {
    ErrorHandler(error);
    return rejectWithValue(error);
  }
});

export const searchProperties = createAsyncThunk<
  any,
  string,
  { state: RootState; rejectValue: any }
>("properties/searchProperties", async (searchQuery, { rejectWithValue }) => {
  try {
    const response = await API.get(ENDPOINTS.SEARCH_PROPERTIES(searchQuery));
    return response;
  } catch (error: any) {
    if (error.response && error.response.status === 404) {
      toast.error(error.response.data.error || error.response.data.message, {
        position: "top-right",
      });
      return error;
    }
    ErrorHandler(error);
    return error;
  }
});


export const searchByLocation = createAsyncThunk<
  any,
  {
    latitude: number | string;
    longitude: number | string;
    city?: string;
    neighborhood?: string;
    radius?: number;
    page?: number;
    per_page?: number;
  },
  { state: RootState; rejectValue: any }
>(
  "properties/searchByLocation",
  async (params, { rejectWithValue }) => {
    try {
      const qp = new URLSearchParams();
      if (params.latitude) qp.append("latitude", String(params.latitude));
      if (params.longitude) qp.append("longitude", String(params.longitude));
      if (params.city) qp.append("city", params.city);
      if (params.neighborhood) qp.append("neighborhood", params.neighborhood);
      qp.append("radius", String(params.radius ?? 5));
      qp.append("page", String(params.page ?? 1));
      qp.append("per_page", String(params.per_page ?? 10));

      const query = qp.toString();
      const response = await API.get(ENDPOINTS.SEARCH_PROPERTIES_BY_LOCATION(query));
      return response; // ✅ same shape as searchProperties
    } catch (error: any) {
      if (error?.response?.status === 422) {
        toast.error(error.response.data?.error || "Latitude and longitude are required.", {
          position: "top-right",
        });
        return rejectWithValue(error.response?.data);
      }

      if (error?.response?.status === 404) {
        toast.info("No properties found nearby.", { position: "top-right" });
        return rejectWithValue(error.response?.data);
      }

      ErrorHandler(error);
      return rejectWithValue(error);
    }
  });

export const searchPropertiesFull = createAsyncThunk<
  any,
  {
    q: {
      latitude?: number;
      longitude?: number;
      min_price?: number;
      max_price?: number;
      property_type_ids?: string[]; // ✅ CHANGED: Make it an array
    };
    page?: number;
    per_page?: number;
  },
  { state: RootState; rejectValue: any }
>(
  "properties/searchPropertiesFull",
  async (params, { rejectWithValue }) => {
    try {
      const queryParams = new URLSearchParams();
      
      queryParams.append("page", String(params.page ?? 1));
      queryParams.append("per_page", String(params.per_page ?? 10));

      if (params.q.latitude) {
        queryParams.append("q[latitude]", String(params.q.latitude));
      }
      if (params.q.longitude) {
        queryParams.append("q[longitude]", String(params.q.longitude));
      }
      if (params.q.min_price !== undefined && params.q.min_price > 0) {
        queryParams.append("q[min_price]", String(params.q.min_price));
      }
      if (params.q.max_price !== undefined && params.q.max_price < 5000) {
        queryParams.append("q[max_price]", String(params.q.max_price));
      }
      
      // ✅ CHANGED: Append multiple property_type_ids as array
      if (params.q.property_type_ids && params.q.property_type_ids.length > 0) {
        params.q.property_type_ids.forEach((id) => {
          queryParams.append("q[property_type_ids][]", id);
        });
      }

      const query = queryParams.toString();
      console.log("🔍 Full search query:", query);

      const response = await API.get(ENDPOINTS.SEARCH_PROPERTIES(query));
      return response;
    } catch (error: any) {
      if (error?.response?.status === 422) {
        toast.error(error.response.data?.error || "Invalid search parameters", {
          position: "top-right",
        });
        return rejectWithValue(error.response?.data);
      }

      ErrorHandler(error);
      return rejectWithValue(error);
    }
  }
);







export const cityProperties = createAsyncThunk<
  any,
  string,
  { state: RootState; rejectValue: any }
>("properties/searchProperties", async (searchQuery, { rejectWithValue }) => {
  try {
    const response = await API.get(ENDPOINTS.CITY_PROPERTIES(searchQuery));
    return response;
  } catch (error: any) {
    if (error.response && error.response.status === 404) {
      toast.error(error.response.data.error || error.response.data.message, {
        position: "top-right",
      });
      return error;
    }
    ErrorHandler(error);
    return error;
  }
});

export const searchCategory = createAsyncThunk<
  any,
  string,
  { state: RootState; rejectValue: any }
>("properties/searchProperties", async (searchQuery, { rejectWithValue }) => {
  try {
    const response = await API.get(ENDPOINTS.SEARCH_PROPERTIES(searchQuery));
    return response;
  } catch (error: any) {
    // ErrorHandler(error);
    return error;
  }
});

export const getPropertyCategories = createAsyncThunk<
  any, // Payload type for successful response (you may want to type this more strictly)
  void,
  { state: RootState; rejectValue: any }
>("properties/propertiesCategories", async (_, { rejectWithValue }) => {
  try {
    const response = await API.get(ENDPOINTS.PROPERTY_CATEGORY);
    return response; // Returning data directly, which contains user info
  } catch (error) {
    ErrorHandler(error);
    return rejectWithValue(error);
  }
});

export const getPropertyType = createAsyncThunk<
  any, // Payload type for successful response (you may want to type this more strictly)
  void,
  { state: RootState; rejectValue: any }
>("properties/propertyTypes ", async (_, { rejectWithValue }) => {
  try {
    const response = await API.get(ENDPOINTS.GET_ALL_PROPERTY_TYPE);
    return response; // Returning data directly, which contains user info
  } catch (error) {
    ErrorHandler(error);
    return rejectWithValue(error);
  }
});

export const createProperties = createAsyncThunk<
  any, // Payload type for successful response
  any, // Payload type for the request body
  { state: RootState; rejectValue: any }
>("stay/createProperties", async (payload, { rejectWithValue }) => {
  try {
    const response = await API.post(ENDPOINTS.CREATE_PROPRTIES, payload);
    // Ensure the correct shape of the response is returned
    return response; // Assuming the data you need is inside 'data'
  } catch (error) {
    ErrorHandler(error); // Handle error with your custom error handler
    return rejectWithValue(error); // Return error with rejectWithValue
  }
});

export const updateProperties = createAsyncThunk<
  any, // Payload type for successful response
  any,
  { state: RootState; rejectValue: any }
>("stay/updateProperties", async (payload, { rejectWithValue }) => {
  try {
    const response = await API.put(
      `${ENDPOINTS.UPDATE_PROPERTIES}/${payload?.property?.id}`,
      payload
    );
    // Ensure the correct shape of the response is returned
    return response;
  } catch (error) {
    ErrorHandler(error);
    return rejectWithValue(error);
  }
});

export const uploadImageProperties = createAsyncThunk<
  any, // Payload type for successful response
  FormData, // Accept FormData as the payload type
  { state: RootState; rejectValue: any }
>("property/uploadImageProperties", async (formData, { rejectWithValue }) => {
  try {
    let propertyId = formData.get("property[id]");

    // If 'id' is missing, append it (you can replace globalId or id as per your logic)
    if (!propertyId) {
      propertyId = formData.get("id"); // Assuming 'id' might be present directly in FormData
    }

    if (!propertyId) {
      return rejectWithValue("Property ID is required");
    }

    // Send the FormData with the propertyId appended dynamically
    const response = await API.put(
      `${ENDPOINTS.UPDATE_PROPERTIES}/${propertyId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    // Return the response data
    return response;
  } catch (error) {
    // Handle error using the ErrorHandler
    ErrorHandler(error);
    return rejectWithValue(error);
  }
});

export const getallupdateProperties = createAsyncThunk<
  any,
  { propertyId?: string; queryParams?: Record<string, any> }, // make propertyId optional
  { state: RootState; rejectValue: any }
>("stay/PropertyToEdit", async (payload, { rejectWithValue }) => {
  try {
    const { propertyId, queryParams = {} } = payload;
    if (!propertyId) {
      throw new Error("propertyId is required");
    }

    const response = await API.get(
      `${ENDPOINTS.GET_ALL_UPDATE_PROPERTY_DETAILS}/${propertyId}`,
      {
        params: queryParams,
      }
    );

    return response;
  } catch (error) {
    ErrorHandler(error);
    return rejectWithValue(error);
  }
});

export const getallPropertieslisting = createAsyncThunk<
  any, // Payload type for successful response
  any,
  { state: RootState; rejectValue: any }
>("stay/PropertyToEdit", async (payload, { rejectWithValue }) => {
  try {
    const response = await API.get(
      `${ENDPOINTS.GET_PROPERTY_Listing(payload.page, payload.query)}`
    );
    // Ensure the correct shape of the response is returned
    return response;
  } catch (error) {
    ErrorHandler(error);
    return rejectWithValue(error);
  }
});

export const updatePropertiesListingStatus = createAsyncThunk<
  any, // Payload type for successful response
  any,
  { state: RootState; rejectValue: any }
>("stay/updateProperties", async (payload, { rejectWithValue }) => {
  try {
    const response = await API.put(
      `${ENDPOINTS.UPDATE_PROPERTY_LISTING}/${payload?.property?.id}`,
      payload
    );
    // Ensure the correct shape of the response is returned
    return response;
  } catch (error) {
    ErrorHandler(error);
    return rejectWithValue(error);
  }
});

export const updateImagesProperties = createAsyncThunk<
  any, // Payload type for successful response
  any, // Expecting the property to be of type FormData
  { state: RootState; rejectValue: any }
>("stay/updateProperties", async (formData: FormData, { rejectWithValue }) => {
  try {
    // Ensure the property has the correct ID in the payload
    const id = formData.get("property[id]"); // Use get('property[id]') to retrieve the ID
    const response = await API.put(
      `${ENDPOINTS.UPDATE_PROPERTIES}/${id}`, // Use the retrieved ID in the URL
      formData // Sending the FormData object
    );
    // Ensure the correct shape of the response is returned
    return response; // Assuming the actual response data is in response.data
  } catch (error) {
    ErrorHandler(error);
    return rejectWithValue(error);
  }
});

export const getAmenitiesProperty = createAsyncThunk<
  any, // Payload type for successful response (you may want to type this more strictly)
  void,
  { state: RootState; rejectValue: any }
>("properties/amenitiesProperty", async (_, { rejectWithValue }) => {
  try {
    const response = await API.get(ENDPOINTS.AMENITIES_PROPERTIES);
    return response; // Returning data directly, which contains user info
  } catch (error) {
    ErrorHandler(error);
    return rejectWithValue(error);
  }
});

export const getRoomAmenitiesProperty = createAsyncThunk<
  any, // Payload type for successful response (you may want to type this more strictly)
  void,
  { state: RootState; rejectValue: any }
>("properties/roomamenitiesCategories", async (_, { rejectWithValue }) => {
  try {
    const response = await API.get(ENDPOINTS.ROOM_AMENITIES_PROPERTIES);
    return response; // Returning data directly, which contains user info
  } catch (error) {
    ErrorHandler(error);
    return rejectWithValue(error);
  }
});

export const getExclusiveProperty = createAsyncThunk<
  any, // Payload type for successful response (you may want to type this more strictly)
  void,
  { state: RootState; rejectValue: any }
>("properties/exclusiveProperty", async (_, { rejectWithValue }) => {
  try {
    const response = await API.get(ENDPOINTS.EXCLUSIVE_PROPERTIS);
    return response;
  } catch (error) {
    ErrorHandler(error);
    return rejectWithValue(error);
  }
});

export const getFeaturedProperty = createAsyncThunk<
  any, // Payload type for successful response (you may want to type this more strictly)
  void,
  { state: RootState; rejectValue: any }
>("properties/featuredProperty", async (_, { rejectWithValue }) => {
  try {
    const response = await API.get(ENDPOINTS.FEATURES_PROPERTY);
    return response;
  } catch (error) {
    ErrorHandler(error);
    return rejectWithValue(error);
  }
});

export const getFeaturesProperty = createAsyncThunk<
  any, // Payload type for successful response (you may want to type this more strictly)
  void,
  { state: RootState; rejectValue: any }
>("properties/featuresCategories", async (_, { rejectWithValue }) => {
  try {
    const response = await API.get(ENDPOINTS.GET_ALL_FEATURES_STATUS);
    return response; // Returning data directly, which contains user info
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getAllReview = createAsyncThunk<
  any, // Payload type for successful response (you may want to type this more strictly)
  void,
  { state: RootState; rejectValue: any }
>("properties/allreview ", async (_, { rejectWithValue }) => {
  try {
    const response = await API.get(ENDPOINTS.GETALLREVIEWS);
    return response; // Returning data directly, which contains user info
  } catch (error) {
    ErrorHandler(error);
    return rejectWithValue(error);
  }
});

export const getRoomFeaturesProperty = createAsyncThunk<
  any, // Payload type for successful response (you may want to type this more strictly)
  void,
  { state: RootState; rejectValue: any }
>("properties/roomfeaturesCategories", async (_, { rejectWithValue }) => {
  try {
    const response = await API.get(ENDPOINTS.ROOM_FEATURES_PROPERTIES);
    return response; // Returning data directly, which contains user info
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getHouseRule = createAsyncThunk<
  any, // Payload type for successful response (you may want to type this more strictly)
  void,
  { state: RootState; rejectValue: any }
>("properties/houseRule", async (_, { rejectWithValue }) => {
  try {
    const response = await API.get(ENDPOINTS.HOUSE_RULE);
    return response; // Returning data directly, which contains user info
  } catch (error) {
    ErrorHandler(error);
    return rejectWithValue(error);
  }
});

export const getBookings = createAsyncThunk<
  any,
  { page: number; query?: string }, // Accepts page and optional query
  { state: RootState; rejectValue: any }
>("properties/bookings", async ({ page, query }, { rejectWithValue }) => {
  try {
    const response = await API.get(
      ENDPOINTS.BOOKING_DEATAILS(page, query) // Passing both page and query
    );
    return response; // Returning data directly
  } catch (error) {
    ErrorHandler(error);
    return rejectWithValue(error);
  }
});

export const getRequestBookings = createAsyncThunk<
  any,
  { page: number; query?: string }, // Accepts page and optional query
  { state: RootState; rejectValue: any }
>(
  "properties/requestBookings",
  async ({ page, query }, { rejectWithValue }) => {
    try {
      const response = await API.get(
        ENDPOINTS.MANAGE_REQUEST_BOOKING(page, query) // Passing both page and query
      );
      return response; // Returning data directly
    } catch (error) {
      ErrorHandler(error);
      return rejectWithValue(error);
    }
  }
);

export const getBookingsDetails = createAsyncThunk<
  any, // Payload type for successful response (you may want to type this more strictly)
  any,
  { state: RootState; rejectValue: any }
>("properties/bookings", async (id, { rejectWithValue }) => {
  try {
    const response = await API.get(`${ENDPOINTS.GET_BOOKING_DEATAILS}/${id}`);
    return response; // Returning data directly, which contains user info
  } catch (error) {
    ErrorHandler(error);
    return rejectWithValue(error);
  }
});

export const getBookingDetails = createAsyncThunk<
  any, // Payload type for successful response (you may want to type this more strictly)
  any,
  { state: RootState; rejectValue: any }
>("properties/bookings", async (id, { rejectWithValue }) => {
  try {
    const response = await API.get(`${ENDPOINTS.BOOKING_DETAILS}/${id}`);
    return response; // Returning data directly, which contains user info
  } catch (error) {
    ErrorHandler(error);
    return rejectWithValue(error);
  }
});

export const getUserBookingsDetails = createAsyncThunk<
  any, // Payload type for successful response (you may want to type this more strictly)
  { page: number; query?: string },
  { state: RootState; rejectValue: any }
>("properties/bookings", async ({ page, query }, { rejectWithValue }) => {
  try {
    const response = await API.get(ENDPOINTS.GET_BOOKING_DEATAILS(page, query));
    return response; // Returning data directly, which contains user info
  } catch (error) {
    ErrorHandler(error);
    return rejectWithValue(error);
  }
});

export const getHostBookingsDetails = createAsyncThunk<
  any,
  { page: number; query?: string }, // Accepts page and optional query
  { state: RootState; rejectValue: any }
>("properties/bookings", async ({ page, query }, { rejectWithValue }) => {
  try {
    const response = await API.get(
      ENDPOINTS.HOST_BOOKING_DETAILS(page, query) // Pass both page and query
    );
    return response; // Returning data directly
  } catch (error) {
    ErrorHandler(error);
    return rejectWithValue(error);
  }
});

export const getBookingsQueryDetails = createAsyncThunk<
  any, // Payload type for successful response (you may want to type this more strictly)
  any,
  { state: RootState; rejectValue: any }
>("properties/bookings", async (id, { rejectWithValue }) => {
  try {
    const response = await API.get(
      `${ENDPOINTS.GET_BOOKING_QUERIES_DATA}/${id}`
    );
    return response; // Returning data directly, which contains user info
  } catch (error) {
    ErrorHandler(error);
    return rejectWithValue(error);
  }
});

export const getBookingsQuery = createAsyncThunk<
  any, // Payload type for successful response
  { page: number; query?: string }, // Accepting both `page` and `query`
  { state: RootState; rejectValue: any }
>("properties/queryData", async ({ page, query }, { rejectWithValue }) => {
  try {
    const response = await API.get(
      `${ENDPOINTS.MANAGE_QUERIES_BOOKING(page, query)}`
    );
    return response;
  } catch (error) {
    ErrorHandler(error);
    return rejectWithValue(error);
  }
});

export const getCancellation = createAsyncThunk<
  any, // Payload type for successful response (you may want to type this more strictly)
  void,
  { state: RootState; rejectValue: any }
>("properties/cancelTypes", async (_, { rejectWithValue }) => {
  try {
    const response = await API.get(ENDPOINTS.GET_CANCILATION_DETAILS);
    return response; // Returning data directly, which contains user info
  } catch (error) {
    ErrorHandler(error);
    return rejectWithValue(error);
  }
});

export const getBlog = createAsyncThunk<
  any, // Payload type for successful response (you may want to type this more strictly)
  void,
  { state: RootState; rejectValue: any }
>("properties/blog", async (_, { rejectWithValue }) => {
  try {
    const response = await API.get(ENDPOINTS.All_blogs);
    return response; // Returning data directly, which contains user info
  } catch (error) {
    ErrorHandler(error);
    return rejectWithValue(error);
  }
});

export const updateBookingsQueryDetails = createAsyncThunk<
  any,
  {
    id: number;
    propertyId: number;
    state: string;
    check_in_date?: string;
    check_out_date?: string;
  },
  { state: RootState; rejectValue: any }
>(
  "properties/query",
  async (
    { id, propertyId, state, check_in_date, check_out_date },
    { rejectWithValue }
  ) => {
    try {
      // Build the payload dynamically, including optional properties like check_in_date and check_out_date
      const payload: any = { booking_query: { state } };

      if (check_in_date) {
        payload.booking_query.check_in_date = check_in_date;
      }

      if (check_out_date) {
        payload.booking_query.check_out_date = check_out_date;
      }

      const response = await API.put(
        ENDPOINTS.BOOKING_QUERY(id, propertyId),
        payload
      );
      return response;
    } catch (error: any) {
      ErrorHandler(error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const sendBookingInvoice = createAsyncThunk<
  any,
  InvoicePayload,
  { state: RootState; rejectValue: any }
>("properties/sendBookingInvoice", async (payload, { rejectWithValue }) => {
  try {
    const response = await API.put(
      `${ENDPOINTS.BOOKING_DETAILS}/${payload.booking_id}`,
      payload
    );
    return response;
  } catch (error) {
    ErrorHandler(error);
    return rejectWithValue(error);
  }
});

export const getGetTax = createAsyncThunk<
  any,
  void,
  { state: RootState; rejectValue: any }
>("properties/allTex", async (_, { rejectWithValue }) => {
  try {
    const response = await API.get(ENDPOINTS.GET_TAX);
    return response;
  } catch (error) {
    ErrorHandler(error);
    return rejectWithValue(error);
  }
});

export const getChatBooking = createAsyncThunk<
  any,
  any,
  { state: RootState; rejectValue: any }
>("properties/Chat", async ({ chatId, page }, { rejectWithValue }) => {
  try {
    const response = await API.get(ENDPOINTS.GET_MESSAGE(chatId, page));
    return response;
  } catch (error) {
    ErrorHandler(error);
    return rejectWithValue(error);
  }
});

export const postChatBooking = createAsyncThunk<
  any,
  any,
  { state: RootState; rejectValue: any }
>(
  "properties/Chat",
  async ({ chatId, page, formData }, { rejectWithValue }) => {
    try {
      const response = await API.post(
        ENDPOINTS.GET_MESSAGE(chatId, page),
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return response.data;
    } catch (error) {
      ErrorHandler(error);
      return rejectWithValue(error);
    }
  }
);

export const getBedType = createAsyncThunk<
  any,
  void,
  { state: RootState; rejectValue: any }
>("properties/roomType", async (_, { rejectWithValue }) => {
  try {
    const response = await API.get(ENDPOINTS.ROOM_BED_TYPE);
    return response;
  } catch (error) {
    ErrorHandler(error);
    return rejectWithValue(error);
  }
});

export const bookingQuery = createAsyncThunk<
  any,
  { page: number; query?: string },
  { state: RootState; rejectValue: any }
>("properties/booking", async ({ page, query }, { rejectWithValue }) => {
  try {
    const response = await API.get(
      `${ENDPOINTS.GET_BOOKING_QUERIES(page, query)}`
    );
    return response;
  } catch (error) {
    ErrorHandler(error);
    return rejectWithValue(error);
  }
});

export const deleteInvoice = createAsyncThunk<
  any, // Optionally replace `any` with a stricter type if available
  {
    bookingId: string | number;
    id?: number;
    _destroy: boolean;
    status: string;
  },
  { state: RootState; rejectValue: any }
>(
  "properties/bookings",
  async ({ bookingId, id, _destroy, status }, { rejectWithValue }) => {
    try {
      const response = await API.put(
        `${ENDPOINTS.BOOKING_DETAILS}/${bookingId}`,
        {
          booking: {
            status, // Dynamically setting status here
            invoice_attributes: {
              id,
              _destroy,
            },
          },
        }
      );
      return response.data;
    } catch (error) {
      ErrorHandler(error);
      return rejectWithValue(error);
    }
  }
);

export const deleteImage = createAsyncThunk<
  any,
  { id: number[] },
  { state: RootState; rejectValue: any }
>("properties/deleteImage", async ({ id }, { rejectWithValue }) => {
  try {
    const response = await API.delete(ENDPOINTS.DELETEIMAGE, {
      data: { id },
    });
    return response.data;
  } catch (error) {
    ErrorHandler(error);
    return rejectWithValue(error);
  }
});

export const getRoomType = createAsyncThunk<
  any, // Payload type for successful response (you may want to type this more strictly)
  void,
  { state: RootState; rejectValue: any }
>("properties/bedType", async (_, { rejectWithValue }) => {
  try {
    const response = await API.get(ENDPOINTS.ROOM_TYPE);
    return response; // Returning data directly, which contains user info
  } catch (error) {
    ErrorHandler(error);
    return rejectWithValue(error);
  }
});

export const review = createAsyncThunk<
  any,
  { id: number; review: any },
  { state: RootState; rejectValue: any }
>("properties/review", async ({ id, review }, { rejectWithValue }) => {
  try {
    const response = await API.post(ENDPOINTS.REVIEW(id), review);
    return response;
  } catch (error) {
    ErrorHandler(error);
    return rejectWithValue(error);
  }
});

export const getReviews = createAsyncThunk<
  any,
  any,
  { state: RootState; rejectValue: any }
>("properties/getReviews", async (id, { rejectWithValue }) => {
  try {
    const response = await API.get(ENDPOINTS.GET_ALL_REVIEW(id));
    return response;
  } catch (error) {
    ErrorHandler(error);
    return rejectWithValue(error);
  }
});

export const similar_Properties = createAsyncThunk<
  any,
  {
    property_type_id: number;
    property_category_id: number;
    property_id: number;
  },
  { state: RootState; rejectValue: any }
>(
  "properties/similarProperties",
  async (
    { property_type_id, property_category_id, property_id },
    { rejectWithValue }
  ) => {
    try {
      const url = `${ENDPOINTS.SIMILAR_PROPERTIES}?property_type_id=${property_type_id}&property_category_id=${property_category_id}&property_id=${property_id}`;
      const response = await API.get(url);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getInvoice = createAsyncThunk<
  any,
  {
    start_date?: string;
    end_date?: string;
    type?: string;
    status?: string;
    page: number;
  },
  { state: RootState; rejectValue: any }
>("properties/invoice", async (params, { rejectWithValue }) => {
  try {
    const response = await API.get(ENDPOINTS.INVOICE, { params });
    return response;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const postfavorites = createAsyncThunk<
  any,
  { property_id: number },
  { state: RootState; rejectValue: any }
>("properties/favorites", async ({ property_id }, { rejectWithValue }) => {
  try {
    const response = await API.post(ENDPOINTS.POST_FAVORITES, {
      favorite: { property_id },
    });
    return response;
  } catch (error) {
    ErrorHandler(error);
    return rejectWithValue(error);
  }
});

export const removeFavorite = createAsyncThunk<
  any,
  { property_id: number },
  { rejectValue: any }
>("properties/removeFavorite", async ({ property_id }, { rejectWithValue }) => {
  try {
    const resposne = await API.delete(
      `${ENDPOINTS.POST_FAVORITES}/${property_id}`
    );
    return resposne;
  } catch (error) {
    return rejectWithValue(error);
  }
});
export const getAllfavoritesList = createAsyncThunk<
  any,
  any,
  { state: RootState; rejectValue: any }
>("properties/favorites", async (page, { rejectWithValue }) => {
  try {
    const response = await API.get(ENDPOINTS.GET_FAVORITES(page));
    return response;
  } catch (error) {
    ErrorHandler(error);
    return rejectWithValue(error);
  }
});


export const getBlogdetails = createAsyncThunk<
  any,
  string, // type of the argument (slug is a string)
  { state: RootState; rejectValue: any }
>(
  "properties/blogsDetails",
  async (slug, { rejectWithValue }) => {
    try {
      const response = await API.get(`${ENDPOINTS.GET_BLOGS}/${slug}`);
      return response;
    } catch (error) {
      ErrorHandler(error);
      return rejectWithValue(error);
    }
  }
);


export const contactUs = createAsyncThunk<
  any, // Payload type for successful response
  any, // Payload type for the request body
  { state: RootState; rejectValue: any }
>("stay/contactUs", async (payload, { rejectWithValue }) => {
  try {
    const response = await API.post(ENDPOINTS.Contact_US, payload);
    // Ensure the correct shape of the response is returned
    return response; // Assuming the data you need is inside 'data'
  } catch (error) {
    ErrorHandler(error); // Handle error with your custom error handler
    return rejectWithValue(error); // Return error with rejectWithValue
  }
});

export const blog = createAsyncThunk<
  any, // Success response type
  { slug: any; payload: any }, // Payload type with slug and body
  { state: RootState; rejectValue: any }
>("blog/postComment", async ({ slug, payload }, { rejectWithValue }) => {
  try {
    const response = await API.post(
      ENDPOINTS.POST_COMMENTS(slug),
      payload
    );
    return response;
  } catch (error) {
    ErrorHandler(error);
    return rejectWithValue(error);
  }
});

export const getComments = createAsyncThunk<
  any, // Success response type
  { slug: any; }, // Payload type with slug and body
  { state: RootState; rejectValue: any }
>("blog/getComment", async ({ slug }, { rejectWithValue }) => {
  try {
    const response = await API.get(
      ENDPOINTS.POST_COMMENTS(slug),

    );
    return response;
  } catch (error) {
    ErrorHandler(error);
    return rejectWithValue(error);
  }
});


const propertiesSlice = createSlice({
  name: "properties",
  initialState,
  reducers: {
    setId: (state, action) => {
      state.globalId = action.payload;
    },
    setPropertyToCreate: (state, action) => {
      state.propertyToCreate = action.payload;
    },
    setProperties: (state, action) => {
      state.allProperties = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      getAllProperties.fulfilled,
      (state, action: PayloadAction<any>) => {
        const data = action?.payload;
        state.allProperties = data?.properties;
        state.metaData = data?.meta;
        state.loading = false;
      }
    );
    builder.addCase(
      getGetTax.fulfilled,
      (state, action: PayloadAction<any>) => {
        const data = action?.payload;
        state.allTex = data?.data;
        state.loading = false;
      }
    );
    builder.addCase(
      getAllfavoritesList.fulfilled,
      (state, action: PayloadAction<any>) => {
        const data = action?.payload;
        state.favorites = data?.data;
        state.loading = false;
      }
    );
    builder.addCase(
      getBookingsQuery.fulfilled,
      (state, action: PayloadAction<any>) => {
        const data = action?.payload;
        state.queryData = data?.data;
        state.loading = false;
      }
    );
    builder.addCase(
      getBedType.fulfilled,
      (state, action: PayloadAction<any>) => {
        const data = action?.payload;
        state.bedType = data?.data;
        state.loading = false;
      }
    );
    builder.addCase(
      getChatBooking.fulfilled,
      (state, action: PayloadAction<any>) => {
        const data = action?.payload;
        state.Chat = data?.data;
        state.loading = false;
      }
    );
    builder.addCase(
      getRoomType.fulfilled,
      (state, action: PayloadAction<any>) => {
        const data = action?.payload;
        state.bedType = data?.data;
        state.loading = false;
      }
    );
    builder.addCase(
      getInvoice.fulfilled,
      (state, action: PayloadAction<any>) => {
        const data = action?.payload;
        state.invoiceData = data;
        state.loading = false;
      }
    );
    builder.addCase(
      getPropertyCategories.fulfilled,
      (state, action: PayloadAction<any>) => {
        const data = action?.payload;
        state.propertiesCategories = data?.data;
        state.loading = false;
      }
    );
    builder.addCase(
      getExclusiveProperty.fulfilled,
      (state, action: PayloadAction<any>) => {
        const data = action?.payload;
        state.exclusiveProperty = data?.properties || []
        state.loading = false;
      }
    );

    builder
    .addCase(searchByLocation.pending, (state) => {
      state.loading = true;
    })
    .addCase(searchByLocation.fulfilled, (state, action) => {
      state.loading = false;

      // handle data whether API.get returns .data or full response
      const payload = action.payload?.data ?? action.payload;

      state.allProperties = payload?.properties ?? [];
      state.metaData = payload?.meta ?? {};
    })
    .addCase(searchByLocation.rejected, (state, action) => {
      state.loading = false;
      state.allProperties = [];
      state.metaData = {};
      state.query = { error: action.payload || action.error?.message || "Search failed" };
    });

     // ✅ ADD THESE NEW CASES HERE
  builder
    .addCase(searchPropertiesFull.pending, (state) => {
      state.loading = true;
    })
    .addCase(searchPropertiesFull.fulfilled, (state, action) => {
      state.loading = false;
      const payload = action.payload?.data ?? action.payload;
      state.allProperties = payload?.properties ?? [];
      state.metaData = payload?.meta ?? {};
    })
    .addCase(searchPropertiesFull.rejected, (state, action) => {
      state.loading = false;
      state.allProperties = [];
      state.metaData = {};
      state.query = { 
        error: action.payload || action.error?.message || "Search failed" 
      };
    });


    // ✅ 1. Featured PROPERTIES (property listings)
  builder
    .addCase(getFeaturedProperty.pending, (state) => {
      state.loading = true;
      state.error = null;
      console.log("⏳ Loading featured properties...");
    })
    .addCase(
      getFeaturedProperty.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.featuredProperty = action.payload?.properties || [];
        console.log("✅ Featured properties loaded:", state.featuredProperty);
      }
    )
    .addCase(getFeaturedProperty.rejected, (state, action) => {
      state.loading = false;
     state.error = action.payload?.message || "Failed to load featured properties";
      state.featuredProperty = [];
    });

    builder.addCase(
      getAllReview.fulfilled,
      (state, action: PayloadAction<any>) => {
        const data = action?.payload;
        state.allreview = data.reviews || [];
        state.loading = false;
      }
    );


    builder.addCase(
      bookingQuery.fulfilled,
      (state, action: PayloadAction<any>) => {
        const data = action?.payload;
        state.booking = data?.data;
        state.loading = false;
      }
    );
    builder.addCase(
      getFeaturesProperty.fulfilled,
      (state, action: PayloadAction<any>) => {
        const data = action?.payload;
        state.featuresCategories = data?.data;
        state.loading = false;
      }
    );
    builder.addCase(
      getRoomFeaturesProperty.fulfilled,
      (state, action: PayloadAction<any>) => {
        const data = action?.payload;
        state.roomfeaturesCategories = data?.data;
        state.loading = false;
      }
    );
    builder.addCase(
      getPropertyType.fulfilled,
      (state, action: PayloadAction<any>) => {
        const data = action?.payload;
        state.propertyTypes = data?.data;
        state.loading = false;
      }
    );

    builder.addCase(
      getCancellation.fulfilled,
      (state, action: PayloadAction<any>) => {
        const data = action?.payload;
        state.cancelTypes = data?.data;
        state.loading = false;
      }
    );
    builder.addCase(
      getBlog.fulfilled,
      (state, action: PayloadAction<any>) => {
        const data = action?.payload;
        state.blog = data;
        state.loading = false;
      }
    );
    builder.addCase(
      getComments.fulfilled,
      (state, action: PayloadAction<any>) => {
        const data = action?.payload;
        state.getComment = data;
        state.loading = false;
      }
    );

    builder
  .addCase(getActiveProperties.pending, (state) => {
    state.loading = true;
  })
  .addCase(getActiveProperties.fulfilled, (state, action: PayloadAction<any>) => {
    state.activeProperties = action.payload?.properties || [];
    state.loading = false;
  })
  .addCase(getActiveProperties.rejected, (state) => {
    state.activeProperties = [];
    state.loading = false;
  });

    builder.addCase(
      getBlogdetails.fulfilled,
      (state, action: PayloadAction<any>) => {
        const data = action?.payload;
        state.blogsDetails = data;
        state.loading = false;
      }
    );

    builder.addCase(
      getAmenitiesProperty.fulfilled,
      (state, action: PayloadAction<any>) => {
        const data = action?.payload;
        state.AmenitiesCategories = data?.data;
        state.loading = false;
      }
    );
    builder.addCase(
      getRoomAmenitiesProperty.fulfilled,
      (state, action: PayloadAction<any>) => {
        const data = action?.payload;
        state.roomamenitiesCategories = data?.data;
        state.loading = false;
      }
    );
    builder.addCase(
      getHouseRule.fulfilled,
      (state, action: PayloadAction<any>) => {
        const data = action?.payload;
        state.houseRule = data?.data;
        state.loading = false;
      }
    );
    builder.addCase(
      getBookings.fulfilled,
      (state, action: PayloadAction<any>) => {
        const data = action?.payload;
        state.metaData = data?.meta;
        state.bookings = data?.data;
        state.loading = false;
      }
    );
    builder.addCase(
      getRequestBookings.fulfilled,
      (state, action: PayloadAction<any>) => {
        const data = action?.payload;
        state.metaData = data?.meta;
        state.bookings = data?.data;
        state.loading = false;
      }
    );
    builder.addCase(
      getallupdateProperties.fulfilled,
      (state, action: PayloadAction<any>) => {
        const data = action?.payload;
        state.PropertyToEdit = data?.property;
        state.loading = false;
      }
    );
    builder.addMatcher(
      (action) =>
        [
          getAllProperties.pending.type,
          getPropertyCategories.pending.type,
          getPropertyType.pending.type,
          getInvoice.pending.type,
        ].includes(action.type),
      (state) => {
        state.loading = true;
      }
    );
    builder.addMatcher(
      (action) =>
        [
          getAllProperties.rejected.type,
          getPropertyCategories.rejected.type,
          getPropertyType.rejected.type,
          getallupdateProperties.rejected.type,
          getInvoice.rejected.type,
        ].includes(action.type),
      (state) => {
        state.loading = false;
        state.PropertyToEdit = null;
      }
    );
  },
});

export const { setId, setProperties, setPropertyToCreate } =
  propertiesSlice.actions;

export default propertiesSlice.reducer;
